export default function emailTemplateHtml({ formValues }) {
  const { request_type, first_name, last_name, email, phone, message } =
    formValues || {}

  return `
    <html>
      <head>
        <meta charset="UTF-8" />
        <title>Contact Form</title>
      </head>

      <body style="margin: 0; padding: 0; background: #ffffff; font-family: Arial, Helvetica, sans-serif;">
        <table width="100%" cellpadding="0" cellspacing="0" border="0">
          <!-- Header -->
          <tr>
            <td style="background: #1f1f1f; padding: 20px">
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td>
                    <img
                      src="https://images.ctfassets.net/4cf96ugtfo35/11TOcoE1mTStyOsuUSVInQ/82165a14c4413f4ffc7f76d1bcd8ba52/image-20260330-063311.png"
                      alt="Kohler"
                      width="120"
                      height="40"
                    />
                  </td>
                  <td align="right" style="color: #ffffff; font-size: 18px">
                    Contact Form
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Section Title -->
          <tr>
            <td style="background: #d9d9d9; padding: 10px 20px; font-weight: bold; color: #333;">
              Contact form details
            </td>
          </tr>

          <!-- Content -->
          <tr>
            <td style="padding: 0">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse">
                <tr style="background: #f2f2f2">
                  <td style="padding: 10px 20px; width: 40%">Request Type</td>
                  <td style="padding: 10px 20px">${request_type || ""}</td>
                </tr>

                <tr style="background: #e6e6e6">
                  <td style="padding: 10px 20px">First Name</td>
                  <td style="padding: 10px 20px">${first_name || ""}</td>
                </tr>

                <tr style="background: #f2f2f2">
                  <td style="padding: 10px 20px">Last Name</td>
                  <td style="padding: 10px 20px">${last_name || ""}</td>
                </tr>

                <tr style="background: #e6e6e6">
                  <td style="padding: 10px 20px">Email Address</td>
                  <td style="padding: 10px 20px">
                    <a href="mailto:${email || ""}" style="color: #0073e6; text-decoration: none">
                      ${email || ""}
                    </a>
                  </td>
                </tr>

                <tr style="background: #f2f2f2">
                  <td style="padding: 10px 20px">Mobile Number</td>
                  <td style="padding: 10px 20px">${phone || ""}</td>
                </tr>

                <tr style="background: #d9d9d9">
                  <td style="padding: 10px 20px; vertical-align: top">
                    Request Description
                  </td>
                  <td style="padding: 10px 20px">${message || ""}</td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="background: #1f1f1f; padding: 20px">
              <table width="100%">
                <tr>
                  <td style="color: #cccccc; font-size: 12px">
                    <a href="https://www.kohler.co.id/en/contact-us" style="color: #cccccc; text-decoration: underline">
                      Feedback
                    </a>
                    /
                    <a href="https://www.corporate.kohler.com/privacy-statement" target="_blank" style="color: #cccccc; text-decoration: underline">
                      Privacy Policy
                    </a>
                    <br />
                    <br />© 2026 Kohler Co.
                  </td>

                  <td align="right">
                    <img
                      src="https://images.ctfassets.net/4cf96ugtfo35/11TOcoE1mTStyOsuUSVInQ/82165a14c4413f4ffc7f76d1bcd8ba52/image-20260330-063311.png"
                      alt="Kohler"
                      width="120"
                      height="40"
                    />
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </body>
    </html>
  `
    .replace(/\s+/g, " ")
    .trim()
}
